<template>
  <div class="ele-body teacher-archive-log">
    <el-card shadow="never">
      <el-form :model="table.where" label-width="78px" class="ele-form-search" @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :md="5" :sm="12">
            <el-form-item label="教师姓名:">
              <el-input v-model.trim="table.where.teacherName" placeholder="请输入教师姓名" clearable />
            </el-form-item>
          </el-col>
          <el-col :md="5" :sm="12">
            <el-form-item label="操作类型:">
              <el-select v-model="table.where.type" placeholder="请选择操作类型" clearable class="ele-block">
                <el-option label="提交" value="1" />
                <el-option label="审核" value="2" />
                <el-option label="查看/下载" value="3" />
                <el-option label="归档" value="4" />
                <el-option label="删除" value="5" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="5" :sm="12">
            <el-form-item label="时间范围:">
              <el-date-picker
                v-model="dateRange"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                class="ele-fluid"
              />
            </el-form-item>
          </el-col>
          <el-col :md="5" :sm="12">
            <div class="ele-form-actions">
              <el-button type="primary" icon="el-icon-search" class="ele-btn-icon" @click="search">查询</el-button>
              <el-button @click="reset">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <ele-data-table ref="table" :config="table">
        <template #default="{ index }">
          <el-table-column type="index" :index="index" width="55" align="center" />
          <el-table-column prop="teacherName" label="教师姓名" min-width="110" show-overflow-tooltip />
          <el-table-column prop="typeName" label="档案类型" min-width="120" show-overflow-tooltip />
          <el-table-column prop="docName" label="档案名称" min-width="160" show-overflow-tooltip />
          <el-table-column prop="docNum" label="档案编号" min-width="120" show-overflow-tooltip />
          <el-table-column prop="type" label="操作类型" width="110" align="center">
            <template #default="{ row }">{{ logTypeText(row.type) }}</template>
          </el-table-column>
          <el-table-column prop="checkTeacherName" label="操作人" min-width="110" show-overflow-tooltip />
          <el-table-column prop="status" label="档案状态" width="100" align="center">
            <template #default="{ row }">{{ statusText(row.status) }}</template>
          </el-table-column>
          <el-table-column prop="reason" label="操作说明" min-width="180" show-overflow-tooltip />
          <el-table-column prop="remark" label="备注" min-width="150" show-overflow-tooltip />
          <el-table-column prop="createTime" label="操作时间" min-width="160" show-overflow-tooltip />
        </template>
      </ele-data-table>
    </el-card>
  </div>
</template>

<script>
  const parsePageData = (res) => {
    if (res.resCode == 200) res.code = 0;
    const data = res.data || {};
    if (Array.isArray(data)) {
      res.count = data.length;
      res.data = data;
    } else {
      res.count = data.total || data.count || 0;
      res.data = data.records || data.list || [];
    }
    return res;
  };

  export default {
    name: 'TeacherArchivesLog',
    data() {
      return {
        dateRange: [],
        table: {
          url: '/teacherArchives/getLogList',
          method: 'GET',
          where: {},
          parseData: parsePageData,
        },
      };
    },
    methods: {
      search() {
        this.table.where = Object.assign({}, this.table.where, {
          startTime: this.dateRange && this.dateRange[0],
          endTime: this.dateRange && this.dateRange[1],
        });
        this.$refs.table.reload();
      },
      reset() {
        this.dateRange = [];
        this.table.where = {};
        this.$refs.table.reload();
      },
      logTypeText(type) {
        return { 1: '提交', 2: '审核', 3: '查看/下载', 4: '归档', 5: '删除' }[String(type)] || type || '-';
      },
      statusText(status) {
        return { 0: '待审核', 1: '已通过', 2: '未通过', 3: '已归档', '-1': '已删除' }[String(status)] || status || '-';
      },
    },
  };
</script>

<style scoped>
  .ele-block,
  .ele-fluid {
    width: 100%;
  }
</style>
